import { NgModule } from '@angular/core';
import { TruncatePipe } from './truncate.pipe';

/**
 * A module containing objects associated with the truncate pipe
 */

export class TruncatePipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    TruncatePipe
  ],
  exports: [
    TruncatePipe
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
